var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 131,
    viewBox: "0 0 5 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_2743)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.34595,
    y: 0.489014,
    width: 130.201,
    height: 4.1508,
    rx: 2.0754,
    transform: "rotate(90.0677 4.34595 0.489014)",
    fill: "#CAFFD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.15372,
    y: 14.105,
    width: 16.4091,
    height: 4.10672,
    rx: 2.05336,
    transform: "rotate(90.0677 4.15372 14.105)",
    fill: "#CAE9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_2743"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.34595,
    y: 0.489014,
    width: 130.201,
    height: 4.1508,
    rx: 2.0754,
    transform: "rotate(90.0677 4.34595 0.489014)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.70404165bb6e91c59491efba229e950f.svg";
export { ForwardRef as ReactComponent };